<script>
    import Scene from "./Scene.svelte";
    import StarField from "../pre-comps/StarField.svelte";
    import Planets from "../pre-comps/PlanetarySystem.svelte";

    const layers = [
        StarField,
        Planets,
    ];
</script>

<Scene layers={layers}></Scene>